export function trackEvent(
  eventName: string,
  eventData: Record<string, unknown> = {},
  dataLayer: unknown[] | undefined,
) {
  const defaultDataLayer = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      return window.dataLayer;
    }
  };
  const activeDataLayer = dataLayer || defaultDataLayer();
  if (activeDataLayer) {
    activeDataLayer.push({
      event: eventName,
      ...eventData,
    });
  }
}
